<template>
    <div>
        <Dialog v-model:visible="visible" modal header="Please enter a reason for archiving/unarchive this task in the box below" :style="{ width: '50rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }" :closable="false">
            <base-editor v-model="comment.comment" :errorMessage="formErrors.comment" placeholder="Please enter a reason" />
            <template #footer>
                <div class="flex justify-content-between gap-2 mt-3">
                    <div>
                        <Button label="Cancel" class="p-button-danger" @click="cancel" />
                        <Button label="Submit" @click="submit" />
                    </div>
                </div>
            </template>
        </Dialog>
        <loader-dialog v-if="loading" />
    </div>
</template>
<script setup>
import { BaseEditor } from '../../../../../modules/custom-inputs';
import LoaderDialog from '../../../../../components/LoaderDialog.vue';

import { ref, defineEmits, defineProps, onUnmounted } from 'vue';
import { storeToRefs } from 'pinia';
import { commentStore, formErrorStore } from '../../../../../store/global-stores';
import { CommentSchema, handleErrors } from '../../../../../utilities/schemas';
import { useConfirm } from 'primevue/useconfirm';
// emits
const emit = defineEmits(['hide-dialog', 'comment-added', 'cancelled']);

// props
const props = defineProps({
    taskId: {
        type: Number,
    },
    actionType: String,
});

const confirm = useConfirm();
const { comment } = storeToRefs(commentStore);
const { formErrors } = storeToRefs(formErrorStore);

// states
const visible = ref(true);
const loading = ref(false);

onUnmounted(() => {
    formErrorStore.clearErrors();
});

const submit = async () => {

    const commentAdded = await validateAndSubmit(CommentSchema);
    if (commentAdded) {
        emit('comment-added');
    }
};

const validateAndSubmit = async (schema) => {
    try {
        loading.value = true;

        comment.value.type = props.actionType;
        await schema.validate(comment.value, { abortEarly: false });
        formErrorStore.clearErrors();
        return await addComment();
    } catch (error) {
        if (error.inner && typeof error.inner === 'object') {
            const errors = handleErrors(error);
            formErrorStore.addErrors(errors);
        }
    } finally {
        loading.value = false;
    }
};

const addComment = async () => {
    return await commentStore.addTaskComment(props.taskId);
};

const cancel = (event) => {
    return confirm.require({
        target: event.currentTarget,
        header: 'Confirmation',
        message: 'Are you sure you want to cancel the changes?',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            emit('cancelled');
        },
    });
};
</script>
